import { Pipe, PipeTransform } from '@angular/core';
import { EventItem, League } from '@model';
import { TranslocoService } from '@ngneat/transloco';
import dayjs from 'dayjs';

@Pipe({ name: 'leagueRound' })
export class LeagueRoundPipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform = (eventItem?: EventItem, league?: League): string => {
    let round = 0;
    if (league && eventItem) {
      const sortedEvents = this.sortEvents(league);
      const index = sortedEvents.indexOf(eventItem);
      if (index !== -1) round = index + 1;
    }
    return this.translocoService.translate('league.round', { value: round });
  }

  private sortEvents = (league: League): EventItem[] =>
    [...(league?.events ?? [])].sort((a, b) =>
      dayjs(a.start!).toDate().getTime() - dayjs(b.start!).toDate().getTime()
    );
}
